import { useState } from 'react';
import EmptySection from './EmptySection';
import PregledSlikaPopupUniverzalno from '../../../UI/PregledSlika/PregledSlikaPopupUniverzalno';
import styles from './ProjectSummary.module.css';

const ProjectSummary = ({ project, onEdit }) => {
  const [selectedImg, setSelectedImg] = useState('');

  const handleImageClick = () => {
    if (project?.slika) {
      setSelectedImg(project.slika);
    }
  };

  return (
    <div className={styles.card}>
      {!project ? (
        <div className={styles.emptyWrap}>
          <h3 className={styles.title}>Overall Progress</h3>
          <EmptySection />
        </div>
      ) : (
        <div className={styles.inner}>
          <div className={styles.main}>
            <div className={styles.titleRow}>
              <h3 className={styles.title}>Overall Progress</h3>
              {onEdit && (
                <button
                  type="button"
                  className={styles.editBtn}
                  onClick={onEdit}
                  title="Izmeni progres"
                >
                  <i className="fas fa-pencil-alt" />
                </button>
              )}
            </div>
            <div className={styles.content}>
              <div className={styles.leftBlock}>
                <div className={styles.progressPercent}>
                  {project.procenat}%
                </div>
              </div>

              <div className={styles.progressBarWrapper}>
                <div className={styles.progressBar}>
                  <div
                    className={styles.progressFill}
                    style={{ width: `${project.procenatBar}%` }}
                  />
                </div>
              </div>

              <div className={styles.estimated}>
                <i className="far fa-calendar-alt" />
                <div>
                  <div className={styles.estimatedLabel}>
                    Estimated completion
                  </div>
                  <div className={styles.estimatedValue}>
                    {project.procenjenoZavrsetak}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${styles.thumbnail} ${
              project.slika ? styles.thumbnailClickable : ''
            }`}
            onClick={project.slika ? handleImageClick : undefined}
            role={project.slika ? 'button' : undefined}
            tabIndex={project.slika ? 0 : undefined}
            onKeyDown={
              project.slika
                ? (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleImageClick();
                    }
                  }
                : undefined
            }
          >
            {project.slika ? (
              <img src={project.slika} alt={project.naziv || 'Projekat'} />
            ) : (
              <i className="fas fa-industry" />
            )}
          </div>
        </div>
      )}

      {selectedImg && (
        <PregledSlikaPopupUniverzalno
          selectedImg={selectedImg}
          setSelectedImg={setSelectedImg}
        />
      )}
    </div>
  );
};

export default ProjectSummary;
